<template>
  <v-card class="mx-auto mt-4 pl-2 pr-2" max-width="100%" outlined id="environment-item">
    <v-list-item three-line id="environment-item-height">
      <v-list-item-content>
        <v-row class="mb-1 mt-4">
          <div id="template-name">{{ environment.TemplateName }}</div>
          <div class="ml-8" id="template-name" v-if="sub !== environment.OwnerSub">
            <v-icon class="mr-2" small>far fa-share</v-icon>
            <span>Owner: {{environment.OwnerEmail}}</span>
          </div>
        </v-row>
        <TitleMobile :fqdn="environment.FQDN" :name="environment.EnvironmentName" />
        <TitleDesktop
          :id="environment.Id"
          :fqdn="environment.FQDN"
          :name="environment.EnvironmentName"
          :status="environment.Status"
          :templateStatus="environment.TemplateStatus"
          :snapshotStatus="environment.SnapshotStatus"
          :environment="environment"
          @statusChange="statusChange"
        />
        <CredentialsMobile
          v-if="environment.ApplicationLogin"
          :environment="environment"
          :password="password"
          @togglePassword="togglePassword"
          @copyPassword="copyPassword"
        />
      </v-list-item-content>
    </v-list-item>

    <ActionsMobile :id="environment.Id" :status="environment.Status" />
    <ActionsDesktop
      :environment="environment"
      :password="password"
      @togglePassword="togglePassword"
      @copyPassword="copyPassword"
      :scheduler="environment.SchedulerEnabled"
      :sharedCount="environment.SharedCount"
      :accessLevel="environment.AccessLevel"
      :isOwner="isUserOwner()"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import TitleMobile from "./Mobile/Title";
import TitleDesktop from "./Desktop/Title";
import CredentialsMobile from "./Mobile/Credentials";
import ActionsMobile from "./Mobile/Actions";
import ActionsDesktop from "./Desktop/Actions";

export default {
  data() {
    return {
      hiddenPassword: true,
      password: "********",
    };
  },
  components: {
    TitleMobile,
    TitleDesktop,
    CredentialsMobile,
    ActionsMobile,
    ActionsDesktop,
  },
  props: ["environment"],
  computed: mapGetters(["sub"]),
  methods: {
    ...mapActions(["showSnackbar", "getUserSub"]),
    togglePassword() {
      this.hiddenPassword = !this.hiddenPassword;

      if (this.hiddenPassword) {
        this.password = "********";
      } else {
        this.password = this.environment.ApplicationPassword;
      }
    },
    copyPassword() {
      if (!this.hiddenPassword) {
        const password = document.getElementById(
          `password-${this.environment.Id}`
        );
        const textArea = document.createElement("textarea");
        textArea.value = password.textContent;
        document.body.appendChild(textArea);
        textArea.select();
        textArea.setSelectionRange(0, 9999999);
        document.execCommand("copy");
        textArea.remove();
        this.showSnackbar("Password has been copied!");
      }
    },
    isUserOwner() {
      return this.sub == this.environment.OwnerSub ? true : false;
    },
    statusChange() {
      this.$emit("statusChange");
    },
  },
};
</script>
